import { gql } from '@apollo/client'

export const CREATE_BRAND = gql`
  mutation CreateBrand($name: String!) {
    createBrand(name: $name) {
      brand {
        id
        name
      }
    }
  }
`
